import { resolveBrandColorFromSettings } from 'frontend/features/branding/resolveBrandColorFromSettings';
import { selectBrandingSettings } from 'legacyfrontend/redux/selectors/branding-selectors';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useColors } from './useColors';

/**
 * Accent colors for search result listings (packages, flights, hotels).
 * When Personalizar is published, uses brandColor; otherwise matches legacy useColors().
 */
export const useListingColors = () => {
  const legacy = useColors();
  const brandingSettings = useSelector(selectBrandingSettings);
  const brandColor = resolveBrandColorFromSettings(brandingSettings);

  return useMemo(
    () => ({
      ...legacy,
      background: brandColor ?? legacy.background,
      isPersonalizedListing: Boolean(brandColor),
    }),
    [brandColor, legacy],
  );
};
